import React from 'react'
import { Route, Routes } from 'react-router-dom'

const User_DetailsPage = React.lazy(() => import('../pages/User-DetailsPage'))
const User_HeaderOutlet = React.lazy(
  () => import('../layouts/User-HeaderOutlet'),
)
const User_ListPage = React.lazy(() => import('../pages/User-ListPage'))

export default function Component() {
  return (
    <Routes>
      <Route index element={<User_ListPage />} />
      <Route path=":userId" element={<User_HeaderOutlet />}>
        <Route path="detalhes" element={<User_DetailsPage />} />
      </Route>
    </Routes>
  )
}
